import axios from 'axios';
import { apiMainUrl } from '../apiConfig';

const API_BASE_URL = apiMainUrl + 'AzureSearch'; // Adjust the URL based on your actual API's URL

const triggerIndexer = async (indexerName, token) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/run-indexer/${indexerName}`, null , {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        });
        return response;
    } catch (error) {
        console.error('Error creating conversation:', error);
        return error.response;
    }
};

const getIndexerStatus = async (indexerName, token) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/indexer-status/${indexerName}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response;
    } catch (error) {
        console.error('Error retrieving conversation history:', error);
        return error.response;
    }
};

export const AzureSearchDataService = {
    triggerIndexer,
    getIndexerStatus
}